import React from 'react';
import {useTranslation} from 'react-i18next';

export const NothingHere = ({
    className = '',
    text,
}: {
    className?: string;
    text?: string;
}) => {
    const {t} = useTranslation();

    return (
        <div
            className={`h-100 w-100 d-flex justify-content-center align-items-center ${className}`}>
            <h5>
                <span className="text-muted">
                    {text ?? t('common.nothing_here_yet')}
                </span>
            </h5>
        </div>
    );
};
